module.exports = __webpack_public_path__ + "static/media/arc.fd1b66aa.png";